export enum AdUnitType {
  Unspecified = 'Unspecified',
  Search = 'Search',
  Native = 'Native',
  MobileSearch = 'MobileSearch',
}